package ru.it_mozaika.sender.js.application.frames.stores

import mui.material.*
import mui.material.styles.TypographyVariant
import mui.system.responsive
import mui.system.sx
import react.*
import react.dom.onChange
import ru.it_mozaika.components.AvatarButton
import ru.it_mozaika.sender.common.models.EmailTemplateData
import ru.it_mozaika.sender.common.models.Sender
import ru.it_mozaika.sender.common.models.TemplateType
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.sender.js.application.context.RequestResultContext
import ru.it_mozaika.sender.js.application.context.useStore
import ru.it_mozaika.sender.js.application.context.useTemplate
import ru.it_mozaika.sender.js.application.frames.MainCard
import web.cssom.AlignItems
import web.cssom.JustifyContent
import web.cssom.pct
import web.cssom.px

external interface StoreEditDialogProps: Props {
    var isOpen: Boolean
    var onClose: () -> Unit
}

val storeEditDialog = FC<StoreEditDialogProps> { props ->
    val context = useStore()
    val templateContext = useTemplate()
    val templates = templateContext.templates
    val currentStore = useMemo(context.currentStore){context.currentStore}
    val requestResultContext = useContext(RequestResultContext)
    var isDisabled by useState(true)
    val (name, setName) = useState("")
    val (url, setUrl) = useState("")
    val (confirmationEnabled, setConfirmationEnabled) = useState(false)
    val (confirmEmailTopic, setConfirmEmailTopic) = useState("")
    var confirmationPageUrl by useState("")
    var unsubscribePage by useState<EmailTemplateData>()
    var confirmTemplate by useState<EmailTemplateData>()
    var reviewTemplate by useState<EmailTemplateData>()
    var currentSender by useState<Sender>()
    useEffect(currentStore?.id) {
        if (currentStore != null) {
            setName(currentStore.name)
            setUrl(currentStore.url)
            setConfirmationEnabled(currentStore.confirmationEnabled)
            setConfirmEmailTopic(currentStore.confirmEmailTopic)
            confirmationPageUrl = currentStore.confirmationPageUrl
        }
    }
    useEffect(currentStore?.id, context.sendersList){
        currentSender = context.sendersList.find{it.id == currentStore?.senderId}
    }
    useEffect(templateContext.unsubscribeTemplate?.id){
        unsubscribePage = templateContext.unsubscribeTemplate
    }
    useEffect(templateContext.confirmTemplate?.id){
        confirmTemplate = templateContext.confirmTemplate
    }
    useEffect(templateContext.reviewTemplate?.id){
        reviewTemplate = templateContext.reviewTemplate
    }
    Dialog {
        open = props.isOpen
        fullWidth = true
        sx {
            width = 100.pct
            marginTop = 56.px
            alignItems = AlignItems.center
            justifyContent = JustifyContent.center

        }
        DialogTitle {
            Stack {
                sx {
                    this.width = 100.pct
                    border = 2.px
                    this.alignItems = AlignItems.center
                    this.justifyContent = JustifyContent.spaceBetween
                }
                this.direction = responsive(StackDirection.row)
                this.divider = Divider.create {
                    orientation = Orientation.vertical
                }
                Typography {
                    variant = TypographyVariant.h2
                    +currentStore?.name
                }
                Stack {
                    this.direction = responsive(StackDirection.row)
                    spacing = responsive(2)
                    AvatarButton {
                        this.tooltipTitle = "Назад"
                        onClick = {
                            props.onClose()
                        }
                        mui.icons.material.ArrowBackSharp()
                    }
                    if (isDisabled) {
                        AvatarButton {
                            this.tooltipTitle = "Редактировать"
                            onClick = {
                                isDisabled = false
                            }
                            mui.icons.material.EditSharp()
                        }
                    } else {
                        AvatarButton {
                            this.tooltipTitle = "Сохранить изменения"
                           disabled = currentStore?.confirmationEnabled == confirmationEnabled
                                    && currentStore.name == name
                                    && currentStore.unsubscribePageId == unsubscribePage?.id
                                    && currentStore.url == url
                                    && currentStore.confirmEmailTopic == confirmEmailTopic
                                    && currentStore.confirmationPageId == confirmTemplate?.id
                                    && currentStore.reviewTemplateId == reviewTemplate?.id
                                    && currentStore.senderId == currentSender?.id
                                    && currentStore.confirmationPageUrl == confirmationPageUrl
                            onClick = {
                               isDisabled = true
                                if (currentStore != null) {
                                    Http.post(
                                        "/stores/${currentStore.id}",
                                        query = mapOf("store" to currentStore.id),
                                        body = currentStore.copy(
                                            id = currentStore.id,
                                            name = name,
                                            url = url,
                                            confirmationEnabled = confirmationEnabled,
                                            confirmEmailTopic = confirmEmailTopic,
                                            confirmationPageUrl = confirmationPageUrl,
                                            confirmationPageId = confirmTemplate?.id,
                                            unsubscribePageId = unsubscribePage?.id,
                                            reviewTemplateId = reviewTemplate?.id,
                                            senderId = currentSender?.id
                                        )
                                    ) { response ->
                                        requestResultContext.handleRequestRespond(response)
                                        context.updateStoreList()
                                    }
                                }
                            }
                            mui.icons.material.SaveSharp()
                        }
                    }
                }
            }
        }
        DialogContent {
            MainCard {
                Stack {
                    direction = responsive(StackDirection.column)
                    spacing = responsive(3)
                    sx {
                        padding = 5.px
                    }
                    TextField {
                        id = "store-edit-name-field"
                        label = ReactNode("Название:")
                        disabled = isDisabled
                        value = name
                        this.variant = FormControlVariant.outlined
                        this.onChange = { event ->
                            val value = event.target.asDynamic().value as String
                            setName(value)
                        }
                    }
                    TextField {
                        id = "store-edit-url-field"
                        value = url
                        this.variant = FormControlVariant.outlined
                        disabled = isDisabled
                        label = ReactNode("Url: ")
                        this.onChange = { event ->
                            val value = event.target.asDynamic().value as String
                            setUrl(value)
                        }
                    }
                    FormControl{
                        InputLabel {
                            +"Отправитель:"
                        }
                        Select {
                            color = InputBaseColor.secondary
                            fullWidth = true
                            disabled = isDisabled
                            value = currentSender?.id ?: ""
                            onChange = { e, _ ->
                                currentSender = context.sendersList.find{
                                    it.id == e.target.value
                                }
                            }
                            context.sendersList.forEach {
                                MenuItem {
                                    value = it.id
                                    +it.name
                                }
                            }
                        }
                    }
                    FormControl{
                        InputLabel {
                            +"Шаблон отписки:"
                        }
                       Select {
                           color = InputBaseColor.secondary
                           fullWidth = true
                           disabled = isDisabled
                           label = ReactNode( unsubscribePage?.name ?: "---")
                           value = unsubscribePage?.id ?: ""
                           onChange = { e, _ ->
                               unsubscribePage = templates.find{
                                   it.id == e.target.value
                               }

                           }
                           templates.filter{it.type == TemplateType.Unsubscribe}.forEach {
                               MenuItem {
                                   value = it.id
                                   +it.name
                               }
                           }
                       }
                    }
                    FormControl{
                        InputLabel {
                            +"Шаблон отзыва:"
                        }
                        Select {
                            color = InputBaseColor.secondary
                            fullWidth = true
                            disabled = isDisabled
                            label = ReactNode( reviewTemplate?.name ?: "---")
                            value = reviewTemplate?.id ?: ""
                            onChange = { e, _ ->
                                reviewTemplate = templates.find{
                                    it.id == e.target.value
                                }
                            }
                            templates.filter{it.type == TemplateType.Review}.forEach {
                                MenuItem {
                                    value = it.id
                                    +it.name
                                }
                            }
                        }
                    }
                    FormControlLabel {
                        control = Checkbox.create {
                            disabled = isDisabled
                            color = CheckboxColor.secondary
                            onChange = { _, _ ->
                                setConfirmationEnabled { current ->
                                    !current
                                }
                            }
                            checked = confirmationEnabled
                        }
                        label = ReactNode("Подтверждение подписки:")
                    }
                    if (currentStore != null && confirmationEnabled){
                        TextField {
                            disabled = isDisabled
                            id = "store-edit-topic-field"
                            value = confirmEmailTopic
                            this.variant = FormControlVariant.outlined
                            label = ReactNode("Тема письма: ")
                            this.onChange = { event ->
                                val value = event.target.asDynamic().value as String
                                setConfirmEmailTopic(value)
                            }
                        }
                        TextField{
                            disabled = isDisabled
                            id = "store-edit-confirmation-page-url-field"
                            value = confirmationPageUrl
                            this.variant = FormControlVariant.outlined
                            label = ReactNode("URL Страницы после подтверждения: ")
                            this.onChange = { event ->
                                val value = event.target.asDynamic().value as String
                                confirmationPageUrl = value
                            }
                        }
                        FormControl{
                            InputLabel {
                                +"Шаблон подтверждения подписки:"
                            }
                            Select {
                                color = InputBaseColor.secondary
                                fullWidth = true
                                disabled = isDisabled
                                label = ReactNode( confirmTemplate?.name ?: "---")
                                value = confirmTemplate?.id ?: ""
                                onChange = { e, _ ->
                                    confirmTemplate = templates.find{
                                        it.id == e.target.value
                                    }
                                }
                                templates.filter{it.type == TemplateType.Confirm}.forEach {
                                    MenuItem {
                                        value = it.id
                                        +it.name
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}